<template>
    <v-dialog v-model="getModalImprimirEstoque" persistent max-width="960px" transition="dialog-transition">
        <v-card outlined>
            <v-card-title>Imprimir</v-card-title>
            <v-form class="px-3" ref="formRelatorioEstoque">
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12 md4>
                        <v-select class="mr-2 ml-2" :items="['', ...getEstoques]" v-model="estoque_id" item-text="nome" item-value="id" outlined
                            dense placeholder="Selecione um estoque" label="Estoque" :rules="rules.estoque_id"></v-select>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-autocomplete class="mr-2 ml-2" :items="['', ...getGruposProduto]" v-model="grupo_id" item-text="grupo" item-value="id" outlined
                            dense placeholder="Selecione um grupo" label="Grupo"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-autocomplete class="mr-2 ml-2" :items="['', ...getMarcas]" v-model="marca" outlined item-text="marca" item-value="marca"
                            dense placeholder="Selecione uma marca" label="Marca"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md12>
                        <v-select
                            v-model="fornecedores"
                            item-value="id"
                            item-text="nome_fantasia"
                            :items="getFornecedores"
                            :menu-props="{ maxHeight: '400' }"
                            label="Forncedores"
                            multiple
                            class="ml-2 mr-2"
                            outlined
                            dense
                            chips
                            ></v-select>
                    </v-flex>
                    <v-flex xs12 md12>
                        <v-select
                            v-model="campos_relatorio_selecionados"
                            item-value="value"
                            item-text="label"
                            :items="campos_relatorio"
                            :menu-props="{ maxHeight: '400' }"
                            label="Campos"
                            multiple
                            class="ml-2 mr-2"
                            outlined
                            dense
                            chips
                            ></v-select>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalImprimirEstoque(false)" outlined :loading="$store.getters.getOverlay">Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="imprimir()" outlined :loading="$store.getters.getOverlay">Imprimir</v-btn></v-btn>
            </v-card-actions>
        </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import EstoqueService from "@/services/EstoqueService";
export default {
  data() {
    return {
      estoque_id: "",
      grupo_id: "",
      marca: "",
      fornecedores: [],
      campos_relatorio: [
        {
          label: "Espaço para conferência",
          value: "espaco_conferencia",
        },
        {
          label: "Grupo",
          value: "grupo",
        },
        {
          label: "Marca",
          value: "marca",
        },
        {
          label: "Preço de custo",
          value: "preco_custo",
        },
        {
          label: "Preço de venda",
          value: "preco_venda",
        },
      ],
      campos_relatorio_selecionados: [],
      rules: {
        estoque_id: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  computed: {
    ...mapGetters([
      "getEstoques",
      "getModalImprimirEstoque",
      "getGruposProduto",
      "getMarcas",
      "getFornecedores",
    ]),
  },
  methods: {
    ...mapActions([
      "listarEstoque",
      "setModalImprimirEstoque",
      "listarGruposProduto",
      "listarMarcas",
      "listarFornecedores",
    ]),
    imprimir() {
      if (this.$refs.formRelatorioEstoque.validate() == false) {
        return;
      }

      this.$store.commit("setOverlay", true);
      EstoqueService.imprimir({
        estoqueId: this.estoque_id,
        grupoId: this.grupo_id,
        marca: this.marca,
        fornecedores: this.fornecedores,
        campos_relatorio: this.campos_relatorio_selecionados,
      })
        .then((res) => {
          this.$store.commit("setOverlay", false);
          this.$store.commit("setModalPrint", res.data.pdf_link);
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("setOverlay", false);
          this.$store.commit("snackbarError", "Erro ao gerar relatório.");
        });
      // window.open(`${this.$urlApi}/v1/estoque/${this.estoque_id}/relatorio`)
    },
  },
  created() {
    this.listarEstoque();
    // this.listarGruposProduto();
    this.listarMarcas();
    this.listarFornecedores();
  },
};
</script>